import { Analysis } from 'common-spectrum';
import { hgParseMicromeritics } from 'physical-chemistry-parser';

export function fromMicromeritics(blob) {
  let analysis = new Analysis();
  const parsed = hgParseMicromeritics(blob);

  let meta = {
    ...parsed.meta.header,
    ...parsed.meta.summaryReport,
  };
  analysis.pushSpectrum(
    {
      x: {
        data: parsed.variables.A.data,
        label: parsed.variables.A.label,
        units: parsed.variables.A.units,
        type: 'INDEPENDENT',
      },
      y: {
        data: parsed.variables.B.data,
        label: parsed.variables.B.label,
        units: parsed.variables.B.units,
        type: 'DEPENDENT',
      },
    },
    {
      dataType: 'Hg porosimetry',
      title: meta.Sample,
      meta,
    },
  );

  return analysis;
}
